/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { formatMessage } from "devextreme/localization";
import { Button } from "devextreme-react/button";
import LoadPanel from "devextreme-react/load-panel";
import { Item } from "devextreme-react/toolbar";
import { useSelector, useDispatch } from "react-redux";
import notify from "devextreme/ui/notify";
import { useScreenSize } from "../../../utils/media-query";
import { responseMiddleware, responseOvertime } from "../../../redux/reducers";
import Form, { Label } from "devextreme-react/form";
import {
  IsPermisionPathRequired,
  getOvertimeDeclarant,
} from "../../../redux/actions";
import "./style.scss";
import OvertimeRegistrationTableList from "./OvertimeRegistrationTable";
import UsingIntl from "../../../services/using_intl";
import { axios, getCurrentPath } from "../../../common";
import { useAuth } from "../../../contexts/auth";
import PopupConfig from "../../../common/popup";

const y = new Date().getFullYear(),
  m = new Date().getMonth();

export default function OvertimeRegistrationList() {
  const formData = useRef({});
  const { isSmall, isXSmall } = useScreenSize();
  let dataGrid = useRef(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const { middlewarePath: middleware, loading } =
    useSelector(responseMiddleware);
  const currentPath = getCurrentPath();
  const { overtimeDeclarant, loading: overtimeLoading } =
    useSelector(responseOvertime);
  const { handleOpenPopup, handleClosePopup, popupConfig } = PopupConfig();
  const [isLoading, setIsLoading] = useState(false);

  const { user } = useAuth();
  const [filter, setFilter] = useState({
    Status: [0, 1, 2, 3, 4],
    FromDate: new Date(y, m, 1).toLocaleDateString("en-CA"),
    ToDate: new Date(y, m + 1, 0).toLocaleDateString("en-CA"),
    EmployeeOid: user?.EmployeeOid,
  });

  useEffect(() => {
    dispatch(IsPermisionPathRequired(currentPath));
    UsingIntl("P0022");
  }, [dispatch]);

  useEffect(() => {
    if (middleware) {
      const { ReadState, NavigateState } = middleware;
      if (
        (NavigateState !== undefined && !NavigateState) ||
        (ReadState !== undefined && !ReadState)
      ) {
        history.push("/403");
        return;
      }
    }
  }, [middleware]);

  const handleChangeSelectBox = async () => {
    const newPayload = {
      ...filter,
      Status: filter.Status !== null ? `${filter.Status}` : null,
    };
    dispatch(getOvertimeDeclarant(newPayload));
  };
  useEffect(() => {
    handleChangeSelectBox();
  }, [filter.Status]);

  const renderActions = ({ data }) => {
    return (
      <>
        {data?.RequestStatus === 0 &&
        data?.CreatedByEmpCode === user?.EmployeeCode ? (
          <>
            <Button
              type="danger"
              stylingMode="outlined"
              // text={formatMessage("Cancel")}
              icon="close"
              onClick={() => handleOpenPopup(data)}
              className="button-rounded mr-2"
            />
            <Button
              type="default"
              stylingMode="outlined"
              icon="/assets/images/icon-edit.svg"
              onClick={() =>
                history.push(`/overtime/overtime-registration/${data.Oid}`)
              }
              className="button-rounded"
            />
          </>
        ) : null}
      </>
    );
  };

  const handleCancelRegistration = async () => {
    const payload = {
      Oid: popupConfig?.data.Oid,
      CancelReason: formData.current.CancelReason,
    };
    const { status } = await axios.post("CancelRegistOT", payload);
    if (status !== 200) {
      handleChangeSelectBox();
      notify("Registration has not been canceled", "error", 3000);
      return;
    }
    notify("Registration has been canceled", "success", 3000);
    handleChangeSelectBox();
    handleClosePopup();
    history.push("/overtime/overtime-registration/list");
  };

  const renderViewPopup = () => {
    return (
      <Popup
        visible={popupConfig.popupVisible}
        onHiding={handleClosePopup}
        title={formatMessage("PopupTitle")}
        showTitle={true}
        width={isSmall || isXSmall ? "100%" : "550px"}
        height={isSmall || isXSmall ? "400px" : "400px"}
        borderRadius={10}
        closeOnOutsideClick={false}
      >
        <Form formData={formData.current}>
          <Item dataField="CancelReason" editorType="dxTextArea" colSpan={2}>
            <Label text={formatMessage("CancelReason")} />
          </Item>
        </Form>
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={handleCancelRegistration}
          options={{
            icon: "save",
            type: "success",
            text: formatMessage("Save"),
          }}
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={handleClosePopup}
          options={{
            icon: "close",
            type: "primary",
            text: formatMessage("Cancel"),
          }}
        />
      </Popup>
    );
  };

  return (
    <div>
      <LoadPanel visible={loading} />
      <LoadPanel visible={isLoading} />
      <LoadPanel visible={overtimeLoading} />
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("OvertimeRegistration")}
          </div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/overtime-registration/list" className={"breadcrumb-item"}>
            {formatMessage("Overtime")}
          </Link>
          <span className={"breadcrumb-item active"}>
            {formatMessage("OvertimeRegistration")}
          </span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-body"}>
          {popupConfig.popupVisible && renderViewPopup()}

          <OvertimeRegistrationTableList
            dataGrid={dataGrid}
            renderActions={renderActions}
            middleware={middleware}
            handleChangeSelectBox={handleChangeSelectBox}
            filter={filter}
            setFilter={setFilter}
            dataSource={overtimeDeclarant}
            setIsLoading={setIsLoading}
          />
        </div>
      </div>
    </div>
  );
}
